import {
  Box,
  Paper,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  CircularProgress,
  Alert,
  Chip,
  InputAdornment,
  IconButton,
  Button,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { OuterBox, BookingDonePopup } from "../../components";
import { useAxios } from "../../hooks";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useRef, useState } from "react";
import ENV from "../../config/config";

const GateEntryRequest = () => {
  const location = useLocation();
  const axios = useAxios({ baseURL: "mox_api_2" });
  const { visitorData } = useSelector((state) => state.memberDetails);

  const journeyWindowRef = useRef(null);
  const checkIntervalRef = useRef(null);
  const [bookingDoneOpen, setBookingDoneOpen] = useState(false);

  const handleStartJourney = () => {
    // Generate a unique session ID and timestamp to ensure fresh session
    const timestamp = Date.now();
    const randomId = Math.random().toString(36).substr(2, 9);

    const URL_PREFIX = ENV === "main" ? "" : ENV + ".";

    // Create URL with unique parameters to force fresh session
    const url = `https://${URL_PREFIX}digipass.verismart.ai/independent/appointment-booking?premises_id=${visitorData.premisesID}&session=${timestamp}&t=${timestamp}&r=${randomId}&is_guard_created=true&clearStorage=false`;
    // const url = `http://localhost:3000/independent/appointment-booking?premises_id=${"0b715d7d56a24c9eb134a4d4a4804e11"}&session=${timestamp}&t=${timestamp}&r=${randomId}&is_guard_created=true&clearStorage=false`;

    // Open in new window
    const newWindow = window.open(
      url,
      "JourneyWindow",
      "width=1200,height=800,scrollbars=yes,resizable=yes"
    );

    if (newWindow) {
      journeyWindowRef.current = newWindow;

      // Listen for messages from the iframe window
      const handleMessage = (event) => {
        const targetOrigin = `https://${URL_PREFIX}digipass.verismart.ai`;
        if (event.origin === targetOrigin) {
          if (event.data && event.data.type === "JOURNEY_COMPLETE") {
            // Close the window when journey is complete
            if (journeyWindowRef.current && !journeyWindowRef.current.closed) {
              journeyWindowRef.current.close();
              journeyWindowRef.current = null;
            }
            window.removeEventListener("message", handleMessage);
            if (checkIntervalRef.current) {
              clearInterval(checkIntervalRef.current);
              checkIntervalRef.current = null;
            }
            setBookingDoneOpen(true);
          }
        }
      };

      window.addEventListener("message", handleMessage);

      // Fallback: Check if window is closed manually or check for completion
      // This is a backup in case postMessage doesn't work
      checkIntervalRef.current = setInterval(() => {
        if (journeyWindowRef.current && journeyWindowRef.current.closed) {
          // Window was closed manually
          journeyWindowRef.current = null;
          window.removeEventListener("message", handleMessage);
          clearInterval(checkIntervalRef.current);
          checkIntervalRef.current = null;
        }
      }, 1000);
    } else {
      alert("Please allow popups for this site to start the journey.");
    }
  };
  console.log(visitorData, "visitorData");

  return (
    <OuterBox>
      <Box sx={{ maxWidth: 1200, margin: "0 auto", mt: 4 }}>
        <Paper
          elevation={3}
          sx={{
            p: 3,
            mb: 3,
            background:
              "linear-gradient(135deg, rgb(255, 255, 255), rgb(255, 255, 255))",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            onClick={handleStartJourney}
            sx={{
              mt: 2,
              backgroundColor: "rgb(57, 54, 239)",
              color: "#fff",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "rgb(57, 54, 239)",
              },
            }}
          >
            Start Journey
          </Button>
        </Paper>
      </Box>
      <BookingDonePopup
        open={bookingDoneOpen}
        onClose={() => setBookingDoneOpen(false)}
      />
    </OuterBox>
  );
};

export default GateEntryRequest;
